import React, { useState } from "react";
import "./EATooltip.scss";
import useDesktopSize from "../../../../utils/hooks/useDesktopSize";

interface IProps {
  content: React.ReactNode; // Tooltip content
  children: React.ReactNode; // The element to hover over
  position?: "top" | "right" | "bottom" | "left";
  fullWidth?: boolean; // Nowy prop dla court grid
}

const EATooltip: React.FC<IProps> = ({ content, children, position = "top", fullWidth = false }) => {
  const [visible, setVisible] = useState(false);
  const isDesktop = useDesktopSize();

  return (
    <div
      className={`tooltip-wrapper ${fullWidth ? "tooltip-wrapper--full-width" : ""}`}
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
      onFocus={() => setVisible(true)}
      onBlur={() => setVisible(false)}
    >
      {children}
      {visible && content && isDesktop && (
        <div className={`tooltip-box tooltip-${position}`} role="tooltip">
          {content}
        </div>
      )}
    </div>
  );
};

export default EATooltip;
